import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import LinkPicker from './LinkPicker.js';
import AlignPicker from './AlignPicker.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import FontPicker from './FontPicker.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class OrderSummery extends React.Component {
	constructor(props) {	
		super(props);
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);

		this.items = this.items.bind(this);
		this.image = this.image.bind(this);
		this.quantity = this.quantity.bind(this);
		this.details = this.details.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onButtonChange = this.onButtonChange.bind(this);
		this.onTextChange = this.onTextChange.bind(this);
		
	}

	onButtonChange(e) {
		this.props.setComponentState(this.el().id,{'button_text':e.target.value});
	}

	onTextChange(e) {
		this.props.setComponentState(this.el().id,{[e.target.getAttribute('data-id')]:e.target.value});
	}

	handleChange(id,s) {
		let changes = {};
    	changes[id] = s; 
		this.props.setComponentState(this.el().id,changes);
	}

	el() {
    	return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    items() {
    	let lines = [];
    	const products = [
    		{
    			'id':1,
    			'name':'Product line 1',
    			'sum':200,
    			'image': 'https://cdn.crall.io/uploads/test.jpg',
    			'quantity': 2
    		},
    		{
    			'id':2,
    			'name':'Product line 2',
    			'sum':100,
    			'image': 'https://cdn.crall.io/uploads/test.jpg',
    			'quantity': 1
    		}
    	];

    	products.map((item) => {
    		lines.push(
    				<tr key={item.id}>
						<td className="table-width-20 table-top" style={{padding:'5px'}}>
							{this.image(item)}
						</td>

						<td className="table-width-60 " style={{padding:'5px',color:this.el().text_color}}>
							{this.details(item)}
						</td>

						<td className="table-width-10" style={{padding:'5px',color:this.el().text_color}}>
							{this.quantity(item)}
						</td>
						
						<td className="table-width-10 " style={{padding:'5px',color:this.el().text_color}}>
							{this.sum(item)}
						</td>
						
					</tr>
    		);
    	});

    	return lines;
    }

    image(item) {
    	return (
    		<table className="table-block">
    			<tbody>
    				<tr>
    					<td>
    						<img src={item.image} style={{maxWidth:'130px'}} />
    					</td>
    				</tr>
    			</tbody>
    		</table>
    	)
    }

    quantity(item) {
    	return (
    		<table className="table-block table-text-center">
				<tbody>
					<tr>
						<td>
							<span style={{fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>{item.quantity}</span>
						</td>
					</tr>
				</tbody>
			</table>
    	)
    }

    sum(item) {
    	return (
    		<table className="table-block table-text-right" style={{textAlign:'right'}}>
				<tbody>
					<tr>
						<td>
							<span style={{fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>{item.sum}</span>
						</td>
					</tr>
				</tbody>
			</table>
    	)
    }

    details(item) {
    	return (
    		<table className="table-block table-text-left">
				<tbody>
					<tr>
						<td>
							<span style={{fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>{item.name}</span>
						</td>
					</tr>
				</tbody>
			</table>
    	)
    }
    

	componentDidMount() {
		
	}

    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Order summary" />
	    			
	    			<div className="panel-group panel-group-continuous" id="cart-settings" aria-multiselectable="true" role="tablist">


	    				<SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-settings" title="Container">

	    		                    
							<SidebarElementSetting text="Font style">
								<FontPicker 
									fontId='text_font' 
									sizeId='text_size'
									colorId='text_color'
									font={this.el().text_font} 
									size={this.el().text_size}
									color={this.el().text_color} 
									handleChange={this.handleChange} 
								/>
							</SidebarElementSetting>

	                    </SidebarSettingAccordion>

	                    <SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-translation" title="Translation">

	    					<SidebarElementSetting text="Total">
								<input type="text" value={this.el().translate_total} data-id="translate_total" onChange={this.onTextChange} className="form-control" />
							</SidebarElementSetting>
	                   

	                    </SidebarSettingAccordion>

	    			</div>

	    			
	    		</div>


    		);
    	}else{

    		return (
    			<table className="table-block" style={{width:'100%',fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>
    				<tbody>
    					<tr>
	    					<td style={{padding:this.el().padding}}>
	    						<table className="table-block">
	    							<tbody>
	    								{this.items()}
	    							</tbody>
	    						</table>
	    					</td>
    					</tr>
    					<tr>
    						<td style={{padding:this.el().padding}}>
    							<table className="table-block" style={{width:'100%'}}>
				    				<tbody>
				    					<tr>
					    					<td style={{textAlign:'right'}}>
					    						<table style={{marginLeft:'auto',marginRight:0,width:'50%'}}>
					    							<tbody>
					    								<tr>
					    									<td style={{textAlign:'right',width:'70%'}}>
					    										@@SHIPPING_METHOD@@<br />
					    									</td>
					    									<td style={{textAlign:'right',width:'30%'}}>
					    										79
					    									</td>
					    								</tr>
					    								<tr>
					    									<td style={{textAlign:'right',width:'70%'}}>
					    										{this.el().translate_total}
					    									</td>
					    									<td style={{textAlign:'right',width:'30%'}}>
					    										379
					    									</td>
					    								</tr>
					    							</tbody>
					    						</table>
					    					</td>
				    					</tr>
				    				</tbody>
				    			</table>
    						</td>
    					</tr>
    				</tbody>
    			</table>
	      		
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

OrderSummery = connect(mapStateToProps,mapDispatchToProps)(OrderSummery);

export default OrderSummery;





// WEBPACK FOOTER //
// ./components/builder/OrderSummary.js